import { useMemo } from 'react';
import { useAtom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';
import { format, subDays } from 'date-fns';
interface Selection { startDate: string; endDate: string; channels: string[]; categories: string[] }
export function useBrandHealthSelection(scope: string) {
  const selectionAtom = useMemo(() => atomWithStorage<Selection>(
    `brand-health-selection:${scope}`,
    { startDate: format(subDays(new Date(), 29), 'yyyy-MM-dd'), endDate: format(new Date(), 'yyyy-MM-dd'), channels: [], categories: [] },
    createJSONStorage(() => sessionStorage),
    { getOnInit: true },
  ), [scope]);
  return useAtom(selectionAtom);
}
